import { Decoration_Type } from './../ricos-types';

export const TEXT_COLOR_MODAL_ID = `${Decoration_Type.COLOR}.foreground.picker`;
export const TEXT_HIGHLIGHT_MODAL_ID = `${Decoration_Type.COLOR}.background.picker`;
